function VisitVO(id, visitCard, doctor, date, beginDate, patient, visitType, visitStatus, clinic, refundStatus,
                 ewusStatement, firstForPatientDoctor, firstForPatientClinic, streamingSessionId, downloadReady,
                 office, mainDiagnosis, suspensionDate, address, patientAge, externalSystemIdentifier, servicePrice,
                 serviceName, nfz) {
    this.id = id;

    this.visitCard = visitCard;
    this.doctor = doctor;
    this.date = _.isUndefined(date) ? new Date() : date;
    this.beginDate = beginDate;
    this.patient = patient;
    this.visitType = visitType;
    this.visitStatus = visitStatus;
    this.clinic = clinic;
    this.refundStatus = refundStatus;
    this.ewusStatement = ewusStatement;
    this.firstForPatientDoctor = firstForPatientDoctor;
    this.firstForPatientClinic = firstForPatientClinic;
    this.streamingSessionId = streamingSessionId;
    this.downloadReady = downloadReady;
    this.office = office;
    this.mainDiagnosis = mainDiagnosis;
    this.suspensionDate = suspensionDate;
    this.address = address;
    this.patientAge = patientAge;
    this.externalSystemIdentifier = externalSystemIdentifier;
    this.servicePrice = servicePrice;
    this.serviceName = serviceName;
    this.nfz = nfz;

    var _typeContext = {
        visitCard: VisitCardVO,
        doctor: DoctorVO,
        date: Date,
        beginDate: Date,
        suspensionDate: Date,
        patient: PatientVO,
        clinic: ClinicVO,
        ewusStatement: AttachmentVO,
        office: OfficeVO,
        mainDiagnosis: DiagnosisVO,
        address: AddressVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
